import { render } from "./SignupHeader.vue?vue&type=template&id=04a87a1b"
import script from "./SignupHeader.vue?vue&type=script&lang=js"
export * from "./SignupHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__